import { render, staticRenderFns } from "./LayoutPicker.vue?vue&type=template&id=94a516fa&scoped=true&lang=pug&"
import script from "./LayoutPicker.vue?vue&type=script&lang=js&"
export * from "./LayoutPicker.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPicker.vue?vue&type=style&index=0&id=94a516fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a516fa",
  null
  
)

export default component.exports